import { render, staticRenderFns } from "./ProductAddons.vue?vue&type=template&id=531be066&scoped=true&"
import script from "./ProductAddons.vue?vue&type=script&lang=js&"
export * from "./ProductAddons.vue?vue&type=script&lang=js&"
import style0 from "./ProductAddons.vue?vue&type=style&index=0&id=531be066&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531be066",
  null
  
)

export default component.exports